import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Icon, IconProps } from '@gaiads/telia-react-component-library';

import { HTMLElementProps } from '../../../utils/types';

export interface EditableItemIconsProps {
  showDelete?: boolean;
  onEditClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onDelete?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  setIsEditing?: (isEditing: boolean) => void;
  flexProps?: Partial<React.ComponentProps<typeof Flex>>;
  editIconProps?: Partial<IconProps & HTMLElementProps>;
  deleteIconProps?: Partial<IconProps & HTMLElementProps>;
}

export default function EditableItemIcons(props: EditableItemIconsProps) {
  const { showDelete, onEditClick, onDelete, setIsEditing, flexProps, editIconProps, deleteIconProps } = props;

  const { t } = useTranslation('editableItem');

  const handleEditClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    onEditClick?.(event);
    setIsEditing?.(true);
  };
  const handleDelete = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (showDelete) {
      onDelete?.(event);
    }
  };
  return (
    <Flex className="editable-field__icons" {...flexProps}>
      <Icon
        title={t('titles.edit')}
        name="edit"
        size="sm"
        className="editable-field__icon-edit"
        onClick={handleEditClick}
        clickableAppearance
        data-testid="locale-${locale.id}-edit"
        {...editIconProps}
      />
      <Icon
        title={t('titles.delete')}
        name="delete"
        size="sm"
        margin={{ left: 'md' }}
        className={['editable-field__icon-delete', !showDelete && 'editable-field__icon-delete--hidden']}
        onClick={handleDelete}
        clickableAppearance
        {...deleteIconProps}
      />
    </Flex>
  );
}
